import Icon from "@pdfking/workflow/components/Icon"
import make_translations from "@pdfking/workflow/utils/make_translations"
import { defineComponent, withModifiers } from "vue"
import navigate from "../routes/navigate"
import { MARKDOWN_VIEW } from "../routes/urls"

export default defineComponent({
  computed: {
    translations: () => make_translations("actions"),
  },
  data() {
    return {
      content_mutable: this.content,
    }
  },
  methods: {
    open_editor() {
      navigate(MARKDOWN_VIEW, {
        selector: `#${(this.$refs.container as HTMLElement).id} textarea`,
      })
    },
  },
  props: ["id", "name", "content", "cols", "rows", "placeholder"] as const,
  render() {
    return (
      <div ref="container" class="onhover" style="position: relative">
        <textarea
          ref="main"
          value={this.content_mutable}
          onInput={(e: Event) => {
            this.content_mutable = (e.target as HTMLTextAreaElement).value
          }}
          class="form-control"
          name={this.name}
          placeholder={this.placeholder}
          style="min-height: 200px"
        />
        <div
          class="onhover-show-visibility border border-top-0 border-end-0 bg-white ps-2 pe-2"
          style="position: absolute; top: 1px; right: 1px; cursor: pointer"
        >
          <a
            class="small text-muted clickable"
            onClick={withModifiers(() => this.open_editor(), ["prevent"])}
          >
            {this.translations.actions.CHANGE} <Icon name="ARROW_RIGHT" />
          </a>
        </div>
      </div>
    )
  },
})
